import { render, staticRenderFns } from "./TwitchDemo.vue?vue&type=template&id=cbb7b6e0&scoped=true&"
import script from "./TwitchDemo.vue?vue&type=script&lang=js&"
export * from "./TwitchDemo.vue?vue&type=script&lang=js&"
import style0 from "./TwitchDemo.vue?vue&type=style&index=0&id=cbb7b6e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb7b6e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout,VProgressCircular,VSelect})
